import { Helpers } from '../helpers';

/**
 * Fetches fees from the server for a given amount and project.
 * @returns {{feesAmount: number, totalWithFeesAmount: number}}
 */
export async function fetchFees(feesUrl, amount, projectId) {
  const params = new URLSearchParams({amount, project_id: projectId});
  const response = await fetch(`${feesUrl}?${params}`, {
    headers: {Accept: 'application/json'},
  });

  if (!response.ok) {
    throw new Error(
      `Fees request failed: ${response.status}`
    );
  }

  const data = await response.json();

  return {
    feesAmount: parseFloatSafe(data['fees_amount']),
    totalWithFeesAmount: parseFloatSafe(data['total_with_fees']),
  };
}

/**
 * Validates the subscription amount.
 * @returns {'ok'|'invalid_html'|'empty'|'insufficient_balance'}
 */
export function validateAmount(amount, totalWithFeesAmount, profileBalance, amountInput) {
  if (!amountInput.checkValidity()) return 'invalid_html';
  if (amount === '') return 'empty';
  if (totalWithFeesAmount > profileBalance) return 'insufficient_balance';
  return 'ok';
}

/**
 * Toggles the non-informed investor warning fields.
 * @returns {boolean} true if warnings passed (no blocking warning)
 */
export function applyWarnings(amount, maxRecommendation, userMayHaveWarning, nonInformedFields) {
  const showWarning =
    userMayHaveWarning === true &&
    amount > maxRecommendation;

  nonInformedFields.forEach((element) => {
    element.classList.toggle('d-none', !showWarning);
    element
      .querySelectorAll('input[type="checkbox"]')
      .forEach((input) => {
        input.required = showWarning;
      });
  });

  return true;
}

/**
 * Formats an amount as currency, defaulting to 0,00 € when blank.
 */
export function formatAmount(amount) {
  const parsed = parseFloat(amount);
  return Helpers.numberToCurrency(isNaN(parsed) ? 0 : parsed, 2);
}

export function parseFloatSafe(value) {
  return parseFloat(value ?? 0);
}
